/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React, { useState } from "react"
import { brandColors } from "../Components/EOSThemeProvider"

interface ButtonProps {
  label: string
  onClick: () => void | Promise<any>
  disabled?: boolean
  variant?: "primary" | "secondary"
}

const Btn: React.FC<ButtonProps> = ({ label, onClick, disabled = false, variant = "primary" }) => {
  const [isLoading, setIsLoading] = useState(false)

  const buttonStyles = css`
    position: relative;
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 4px;
    font-weight: 500;
    border: none;
    cursor: ${disabled || isLoading ? "not-allowed" : "pointer"};
    background-color: ${disabled || isLoading
      ? "#ccc"
      : variant === "primary"
      ? `${brandColors.mint}`
      : `${brandColors.lightNight}`};
    color: ${disabled || isLoading ? "#666" : "#fff"};
    transition: background-color 0.3s;
    min-width: 120px;

    &:hover {
      background-color: ${disabled || isLoading
        ? "#ccc"
        : variant === "primary"
        ? `${brandColors.emerald}`
        : `${brandColors.darkNight}`};
    }
  `

  const handleClick = async () => {
    if (disabled || isLoading) {
      return
    }

    setIsLoading(true)
    const startTime = Date.now()

    try {
      const result = await onClick()
      const elapsedTime = Date.now() - startTime

      // Ensure spinner shows for at least 500ms
      if (elapsedTime < 500) {
        await new Promise(resolve => setTimeout(resolve, 500 - elapsedTime))
      }

      return result
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <button css={buttonStyles} onClick={handleClick} disabled={disabled || isLoading}>
      {isLoading && (
        <i
          className="fa fa-spinner fa-spin"
          css={css`
            margin-right: 8px;
          `}
        />
      )}
      {label}
    </button>
  )
}

export default Btn
